import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'
import styled from 'styled-components'

import BuildingIcon from './BuildingIcon'
import TrackingIcon from './TrackingIcon'

/**
 * 運び先検索結果アイコン
 */
const BuildingSearchResultIcon: React.FC = () => {
  return (
    <TrackingIcon>
      <StyledBuildingSearchResultIcon>
        <BuildingIcon
          width="10px"
          height="10px"
          color={CLIENT_SETTINGS.colors.textForMainBackground}
        />
      </StyledBuildingSearchResultIcon>
    </TrackingIcon>
  )
}

const StyledBuildingSearchResultIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: 0 auto;
  background: var(--color-icon-car);
  border: 2px solid var(--color-text-for-main-background);
  border-radius: 50%;
`

export default BuildingSearchResultIcon
